import { useGlobalAlert as globalAlert } from "hooks/useAlert";
import { api } from "services/api.service";
import { mutate } from "swr";
import { isAxiosError } from "utils/helpers";

export async function action({ request, params }: { request: Request; params: Record<string, string | undefined> }) {
  const formData = await request.formData();
  const data = Object.fromEntries(formData.entries());
  const { containersAttributes } = data;

  try {
    const response = await api.request({
      method: "PUT",
      url: `/bulk_orders/${params.manifestId}`,
      data: {
        bulk_order: {
          ...data,
          containersAttributes: JSON.parse((containersAttributes || "[]") as string),
        },
      },
    });

    if (response.status >= 200 && response.status < 300) {
      mutate((key) => typeof key === "string" && key.startsWith("bulk_orders"));
      globalAlert.alertSuccess("Bulk order updated successfully.");
      return null;
    }
    return { error: "Unexpected response" };
  } catch (error: unknown) {
    if (isAxiosError(error)) globalAlert.alertError(`Failed to update bulk order: ${error.response?.data.message}`);
    return { error: true };
  }
}
